<script lang="ts">
	export let errorMessage = "";
	export let error = false;
	export let focus = false;
	export let labelFor = "";
	export let inputName: string | null = null;

	export let outerClassname = "";
	export let labelClassname = "";
	export let spanClassname = "";

</script>

<div class={'outer ' + outerClassname}>
	{#if inputName !== null}
		<label
			class:error
			class:focus={!error && focus}
			class={labelClassname}
			for={labelFor}>{inputName}</label>
	{/if}
	<slot />
	{#if errorMessage !== '' && error}
		<span class:error class={spanClassname}>{errorMessage}</span>
	{/if}
</div>

<style lang="scss">
	div {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	label {
		font-size: 1.125rem;
		transition: all 0.15s;
		color: #e6e7ed;
	}
	span {
		display: block;
		padding-left: 10px;
	}

	.focus {
		color: var(--signature-blue);
		font-weight: 500;
	}

	.error {
		color: var(--error-color-1);
	}

</style>
